<template>
    <div
        :class="`formulate-input-element formulate-input-element--${context.class}`"
        :data-type="context.type"
    >
        <v-select
                v-model="context.model"
                v-bind="context.attributes"
                :options="paginated"
                :searchable="true"
                :clearable="true"
                :filterable="false"
                :components="{Deselect}"
                :placeholder="loading ? 'Loading...' : 'Type to search for a localisation...'"
                label="label"
                @open="onOpen"
                @close="onClose"
                @search="(query) => (search = query)"
            >
                <!-- Open indicator //-->
                <template #open-indicator="{ attributes }">
                    <span v-bind="attributes">
                        <i class="fas fa-caret-down"></i>
                    </span>
                </template>

                <!-- Select options //-->
                <template slot="option" slot-scope="slotProps">
                    <div class="d-flex flex-row align-items-center">
                        <span class="flex-grow">
                            {{ slotProps.label }}<br>
                            <small class="text-muted ml-2">{{ slotProps.value }}</small>
                        </span>
                    </div>
                </template>

                <!-- Selected option -->
                <template slot="selected-option" slot-scope="slotProps">
                    <div class="d-flex flex-row align-items-center">
                        <span class="flex-grow">
                            <strong>{{ slotProps.label }}</strong><br>
                            <small class="text-muted ml-2">{{ slotProps.value }}</small>
                        </span>
                    </div>
                </template>

                <!-- Loading -->
                <template #spinner="{ loading }">
                    <spinner :show="loading" :size="20" />
                </template>

                <!-- Footer //-->
                <template #list-footer>
                    <li v-show="hasNextPage" ref="load" class="loader"></li>
                </template>

            </v-select>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import Spinner from '@/components/spinner';

import { i18n, languageBundle } from '@/i18n';
import { objectToDotNotation } from '@/helper/object';

export default {
    i18n,
    components: {
        vSelect,
        Spinner,
    },
    props: {
        context: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            loading: false,
            observer: null,
            limit: 10,
            search: '',
            messages: [],
            Deselect: {
                render(createElement) {
                    const vm = this;
                    return createElement('i', {
                        attrs: {
                            class: 'fas fa-times',
                        },
                    }, '');
                },
            },
        }
    },
    mounted() {
        const messages = languageBundle[window.Locale];
        this.messages = objectToDotNotation(messages, true);
        this.observer = new IntersectionObserver(this.infiniteScroll);
    },
    computed: {
        filtered() {
            return this.messages.filter(i =>
                Object.values(i).some(v => v.includes(this.search)) ||
                Object.keys(i).some(v => {
                    return v.split('.').some(x => x.includes(this.search));
                })
            );
        },
        paginated() {
            return this.filtered.slice(0, this.limit);
        },
        hasNextPage() {
            return this.paginated.length < this.filtered.length;
        },
    },
    methods: {
        async onOpen() {
            if (this.hasNextPage) {
                await this.$nextTick();
                this.observer.observe(this.$refs.load);
            }
        },
        onClose() {
            this.observer.disconnect();
        },
        async infiniteScroll([{ isIntersecting, target }]) {
            if (isIntersecting) {
                const ul = target.offsetParent;
                const scrollTop = target.offsetParent.scrollTop;
                this.limit += 10;
                await this.$nextTick();
                ul.scrollTop = scrollTop;
            }
        },
    },
};
</script>
